/**
 * Removes the properties in an object where the keys are undefined
 * @param {object} obj The object whose undefined values should be removed

 * @returns {object} The argument object without keys whose value was undefined
 * Example: removeUndefinedProperties({a: '1', b: undefined} => {a: '1'})
 *
 */
const removeUndefinedProperties = (obj) => {
    return Object.entries(obj).reduce((acc, [key, value]) => {
        if (value !== undefined) {
            acc[key] = value;
        }
        return acc;
    }, {});
};
export default removeUndefinedProperties;
//# sourceMappingURL=removeUndefinedProperties.js.map